<template>
  <div
    class="card"
    :class="{ 'card--grey': color === 'grey' }"
  >
    <h3>
      <button
        :id="`accordion-header-${uid}`"
        :aria-controls="`accordion-panel-${uid}`"
        type="button"
        aria-haspopup="true"
        :aria-expanded="isOpened.toString()"
        :class="{ 'ds-button-link-dropdown--active': isOpened }"
        class="ds-button-link-dropdown ds-color-black ds-width-full ds-md-align-items-center card__header"
        :data-track-component-name="$options.name"
        :data-track-title="sectionTitle"
        :data-track-text="title"
        :data-track-date="date"
        :data-track-tag="tagLabel"
        data-j-header
        @click="toggle"
      >
        <span class="ds-width-full ds-display-flex ds-flex-direction-column">
          <span class="ds-width-full ds-display-flex ds-flex-direction-row ds-justify-content-space-between">
            <StatusItem
              :title="title"
              :date="date"
              :icon="icon"
              :description="description"
            />
            <DsIcon
              category="arrows"
              name="chevron-down-small"
              class="card__dropdown-icon"
            />
          </span>
          <span
            v-if="tagLabel"
            class="ds-margin-top-12"
            :style="{ display: 'block' }"
          >
            <span v-if="loading" class="status-loading" :style="{ height: '30px', display: 'block', width: '204px' }" />
            <DsTag
              v-else
              class="status-incident-history--tag"
              :label="tagLabel"
            />
          </span>
        </span>
      </button>
    </h3>
    <transition
      name="ds-expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div
        v-show="isOpened"
        :id="`accordion-panel-${uid}`"
        :aria-labelledby="`accordion-header-${uid}`"
        class="card__panel"
        role="region"
        data-j-panel
      >
        <div class="ds-margin-left-24 ds-padding-left-12 ds-margin-top-12">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DsTag from 'website-design-system/src/atoms/tag/tag';
import DsIcon from 'website-design-system/src/atoms/icon/icon';
import transitionExpand from 'website-design-system/src/utils/mixins/transitions/transition-expand';
import uid from 'website-design-system/src/utils/mixins/uid/uid';
import StatusItem from '@/components/status-item/status-item';
import { isScreenSmall } from '@/utils/screen.js';

export default {
  name: 'StatusCard',
  components: { DsIcon, DsTag, StatusItem },
  mixins: [transitionExpand, uid],
    inject: ['screen', 'loading'],
    props: {
      sectionTitle: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      icon: {
        type: Object,
        default: () => ({ name: '', category: '', color: '' }),
        validator: obj => ['name', 'category', 'color'].every(key => key in obj)
      },
      date: {
        type: String
      },
      description: {
        type: Object,
        default: null
      },
      opened: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: 'light',
        validator: str => ['light', 'grey'].includes(str)
      },
      tagLabel: {
        type: String,
        default: ''
      }
    },
    data: () => ({
        isOpened: false
    }),
  computed: {
      isScreenSmall () {
        return isScreenSmall(this.screen.name)
      }
  },
    created () {
        this.isOpened = this.opened;
    },
    methods: {
        close () {
            this.isOpened = false;
        },
        open () {
            this.isOpened = true;
        },
        toggle () {
            if (this.isOpened) {
                this.close();
            } else {
                this.open();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import 'website-design-system/src/foundation/tokens/variables';
@import 'website-design-system/src/foundation/mixins/mixins';

.card {
  background-color: $color-white;
  border: 1px solid $color-grey-100;
  border-radius: $spacing-6;
  padding: $spacing-24;

  &--grey {
    background-color: $color-grey-025;
    border-color: $color-grey-025;
  }

  &__panel {
    word-break: break-word;
  }

  &__dropdown-icon {
    color: $color-black;
    margin-top: 10px;
  }
}
</style>
